(function (angular, schoolwork12) {
	'use strict';

	schoolwork12.app.k12DataManagement = {
		name: 'schoolwork12.k12DataManagement',
		controllers: {
			k12DataManagement: 'k12DataManagementCtrl',
			addClusterConfig: 'addClusterConfigCtrl',
			clusterConfigItemModal: 'configItemModalCtrl',
			systemConfiguration: 'systemConfigurationCtrl'
		},
		routes: {
			k12DataManagement: '/data-management',
			addClusterConfig: '/add-clusterconfig',
			clusterConfigItemModal: '/configitemmodal',
			systemConfiguration: '/system-config'
		},
		templates: {
			k12DataManagement: 'k12DataManagement/html/viewK12DataManagement.html',
			addClusterConfig: 'k12DataManagement/html/addClusterConfig.html',
			clusterConfigItemModal: 'k12DataManagement/html/clusterConfigItemModal.html',
			systemConfiguration: 'k12DataManagement/html/systemConfiguration.html'
		},
		services: {
			k12DataManagementSvc: 'k12DataMgmtSvc'
		},
		endpoints: {
			getK12DataManagementEndpoint: schoolwork12.app.endpoint.concat('/datamanagement')
		},
		errorMessages: {
			clusterConfigAssociated: 'The following clusters config are associated to schools and cannot be deleted: ',
			clusterConfigNameRequired: 'Cluster Configuration Name is required when creating a new configuration. Please enter a value for this field.',
			clusterConfigDescRequired: 'Cluster Configuration Description is required when creating a new configuration. Please enter a value for this field.',
			clusterConfigItemKeyRequired: "A 'Key' is required when creating a new Configuration Item. Please enter a value for this field.",
			clusterConfigItemValueRequired: "A 'Value' is required when creating a new Configuration Item. Please enter a value for this field.",
			clusterConfigItemRequired: 'There must be at least one Configuration Item added',
			systemConfigNameRequired: 'Name is a required field. Please enter a Name for the system configuration.',
			systemConfigNameUnique: 'Name is already in use by another system configuration. Please enter a unique Name.'
		}
	};

	angular.module(schoolwork12.app.k12DataManagement.name, []);

}(angular, schoolwork12));
